module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_05.14249c64.jpg";